import { SxProps, Theme } from '@mui/material';

/** Shared layout for CRM preview panes — side panel on desktop, full screen on mobile. */
export const previewPanePaperSx: SxProps<Theme> = (theme) => ({
  flex: { xs: 'none', md: '0 0 40%' },
  width: { xs: '100%', md: '40%' },
  minWidth: { xs: 'auto', md: 320 },
  maxWidth: { xs: '100%', md: 560 },
  borderRadius: { xs: 0, md: 3 },
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  bgcolor: 'background.paper',
  position: { xs: 'fixed', md: 'sticky' },
  top: { xs: 0, md: 16 },
  left: { xs: 0, md: 'auto' },
  right: { xs: 0, md: 'auto' },
  bottom: { xs: 0, md: 'auto' },
  height: { xs: '100dvh', md: 'auto' },
  maxHeight: { xs: '100dvh', md: 'none' },
  zIndex: { xs: theme.zIndex.modal, md: 'auto' },
  alignSelf: { xs: 'stretch', md: 'flex-start' },
});

/** Scrollable preview pane body — fills remaining height on full-screen mobile. */
export const previewPaneBodySx: SxProps<Theme> = {
  p: 1,
  overflowY: 'auto',
  flex: { xs: 1, md: 'none' },
  minHeight: { xs: 0, md: 'auto' },
};
